/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/Fields/Number",
  isInvalid,
  onChange
  
}) {
let contactMethodAssociationPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'contact_method_association',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let contactMethodAssociationPhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'contact_method_association',
path: 'phone.number',
validate: fromValidate.phoneNumber,
required: true,
})
let contactMethodAssociationPhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'contact_method_association',
path: 'phone.number',
formatOut: fromFormat.addPrefixIfMissing,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="contact_method_association.phone.number"
 validate="/Data/validate.js phoneNumber"
 invalid={!contactMethodAssociationPhoneNumberIsValidData}
 format="/Data/format.js phoneNumberUS"
 formatOut="/Data/format.js addPrefixIfMissing"
 required={true}
 value={contactMethodAssociationPhoneNumberValueData}
 onChange={contactMethodAssociationPhoneNumberChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}